// Généré par `python manage.py export_default_on_features` depuis
// apps/organisations/modules.py (ADR 0063). Ne pas modifier à la main.
import type { FeatureKey } from "@/features/auth/types";

/** Modules actifs tant que `me` ne les dit pas éteints (`disabled_features`). */
export const DEFAULT_ON_FEATURES: readonly FeatureKey[] = ["insurance"];
